import BaseApi from "./BaseApi";

export default class Permissions extends BaseApi {
    construct() {}

    static async list(accessId, params = {}) {
        return await Permissions.getAxiosInstance().get(
            Permissions.getApiUrl(accessId) + "/list",
            {
                params,
            }
        );
    }

    static async listAll(accessId, params = {}) {
        return await Permissions.getAxiosInstance().get(
            Permissions.getApiUrl(accessId) + "/list-all",
            {
                params,
            }
        );
    }

    static getApiUrl(accessId) {
        return BaseApi.getApiUrl() + "admin/apps/" + accessId + "/permissions";
    }
}